import React from "react";
import { useTranslation } from "react-i18next";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";

export const Copyright = () => {
  const version = process.env.VERSION;
  const { t } = useTranslation();
  const countryCode = sessionStorage.getItem("LSCountryCode");
  const countryUrl = countryCode === "AU" ? "au" : "com";

  return (
    <Typography variant="body2" color="textSecondary" align="center">
      <span>{`Drive Safer version ${version}`}</span>
      <br />
      {t("policies.copyrightLabel")}
      {" © "}
      <Link
        style={{ color: "#76bc21", textDecoration: "none" }}
        href={`https://www.lifesaferisa.${countryUrl}/`}
        target="_blank"
        rel="noopener noreferrer"
      >
        LifeSafer
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
};
